import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { Footer } from '../../components/footer';
import { InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { Seo } from '../../components/seo';
import { styled } from '../../styles/stitches.config';

const Privacy = () => {
    // document.getElementsByTagName('body')[0].style.overflow = "auto";
    const ContentContainer = styled('section', {
        padding: '80px 0 80px 0',
        maxWidth: '780px',
        margin: '0 auto',
        '@bp1': {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        h1: {
            fontFamily: '$default',
            textAlign: 'center',
            fontSize: '36px',
            marginBottom: '56px',
        },
        h2: {
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.1em',
            margin: '0 0 24px 0',
        },
        p: {
            fontFamily: '$lato',
            color: '#585d6c',
            margin: '0 0 24px 0',
            fontSize: '18px',
            lineHeight: '29px',
        }
    });

    return (
        <Layout>
            <Seo
                title={'Privacy Policy - Better Days Skin Co.'}
            />
            <ContentContainer>
                <p>This Privacy Policy describes how BETTER DAYS (the &quot;Site&quot; or &quot;we&quot;) collects, uses, and discloses your Personal Information when you visit or make a purchase from the Site.</p>

                <h2>COLLECTING PERSONAL INFORMATION</h2>
                <p>When you visit the Site, we collect certain information about your device, your interaction with the Site, and information necessary to process your purchases. We may also collect additional information if you contact us for customer support. In this Privacy Policy, we refer to any information that can uniquely identify an individual (including the information below) as &quot;Personal Information&quot;. See the list below for more information about what Personal Information we collect and why.</p>

                <p>Device Information</p>

                <p>
                    <li>Examples of Personal Information collected: version of web browser, IP address, time zone, cookie information, what sites or products you view, search terms, and how you interact with the Site.</li>
                    <li>Purpose of collection: to load the Site accurately for you, and to perform analytics on Site usage to optimize our Site.</li>
                    <li>Source of collection: collected automatically when you access our Site using cookies, log files, web beacons, tags, or pixels.</li>
                    <li>Disclosure for a business purpose: shared with our processor Shopify.</li>
                </p>

                <p>Order information</p>

                <p>
                    <li>Examples of Personal Information collected: name, billing address, shipping address, payment information (including credit card numbers, email address, and phone number.</li>
                    <li>Purpose of collection: to provide products or services to you to fulfil our contract, to process your payment information, arrange for shipping, and provide you with invoices and/or order confirmations, communicate with you, screen our orders for potential risk or fraud, and when in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.</li>
                    <li>Source of collection: collected from you.</li>
                    <li>Disclosure for a business purpose: shared with our processor Shopify.</li>
                </p>

                <p>Customer support information</p>

                <p>
                    <li>Examples of Personal Information collected: name, billing address, shipping address, payment information (including credit card numbers, email address, and phone number.</li>
                    <li>Purpose of collection: to provide customer support.</li>
                    <li>Source of collection: collected from you.</li>
                    <li>Disclosure for a business purpose: shared with our processor Shopify.</li>
                </p>

                <h2>MINORS</h2>
                <p>The Site is not intended for individuals under the age of 18. We do not intentionally collect Personal Information from children. If you are the parent or guardian and believe your child has provided us with Personal Information, please contact us at the address below to request deletion.</p>

                <h2>SHARING PERSONAL INFORMATION</h2>
                <p>We share your Personal Information with service providers to help us provide our services and fulfill our contracts with you, as described above. For example:</p>

                <p>We use Shopify to power our online store. You can read more about how Shopify uses your Personal Information here: https://www.shopify.com/legal/privacy.</p>

                <p>We may share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.</p>

                <h2>BEHAVIOURAL ADVERTISING</h2>
                <p>As described above, we use your Personal Information to provide you with targeted advertisements or marketing communications we believe may be of interest to you. For example:</p>

                <p>We use Google Analytics to help us understand how our customers use the Site. You can read more about how Google uses your Personal Information here: https://policies.google.com/privacy?hl=en. You can also opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.</p>
                <p>For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (&quot;NAI&quot;) educational page at http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.</p>

                <p>You can opt out of targeted advertising by:</p>

                <p>
                    <li>FACEBOOK</li>
                    <li>GOOGLE</li>
                    <li>BING</li>
                </p>
                <p>Additionally, you can opt out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal at: http://optout.aboutads.info/.</p>

                <h2>USING PERSONAL INFORMATION</h2>
                <p>We use your personal Information to provide our services to you, which includes: offering products for sale, processing payments, shipping and fulfillment of your order, and keeping you up to date on new products, services, and offers.</p>

                <h2>COOKIES</h2>
                <p>A cookie is a small amount of information that’s downloaded to your computer or device when you visit our Site. We use a number of different cookies, including functional, performance, advertising, and social media or content cookies. Cookies make your browsing experience better by allowing the website to remember your actions and preferences (such as login and region selection). This means you don’t have to re-enter this information each time you return to the site or browse from one page to another. Cookies also provide information on how people use the website, for instance whether it’s their first time visiting or if they are a frequent visitor.</p>

                <p>We use the following cookies to optimize your experience on our Site and to provide our services.</p>

                <h2>COOKIES NECESSARY FOR THE FUNCTIONING OF THE STORE</h2>
                <p>
                    Name	Function
                    _ab	Used in connection with access to admin.
                    _secure_session_id	Used in connection with navigation through a storefront.
                    cart	Used in connection with shopping cart.
                    cart_sig	Used in connection with checkout.
                    cart_ts	Used in connection with checkout.
                    checkout_token	Used in connection with checkout.
                    secret	Used in connection with checkout.
                    secure_customer_sig	Used in connection with customer login.
                    storefront_digest	Used in connection with customer login.
                    _shopify_u	Used to facilitate updating customer account information.REPORTING AND ANALYTICS
                    Name	Function
                    _tracking_consent	Tracking preferences.
                    _landing_page	Track landing pages
                    _orig_referrer	Track landing pages
                    _s	Shopify analytics.
                    _shopify_fs	Shopify analytics.
                    _shopify_s	Shopify analytics.
                    _shopify_sa_p	Shopify analytics relating to marketing &amp; referrals.
                    _shopify_sa_t	Shopify analytics relating to marketing &amp; referrals.
                    _shopify_y	Shopify analytics.
                    _y	Shopify analytics.
                </p>
                <p>The length of time that a cookie remains on your computer or mobile device depends on whether it is a &quot;persistent&quot; or &quot;session&quot; cookie. Session cookies last until you stop browsing and persistent cookies last until they expire or are deleted. Most of the cookies we use are persistent and will expire between 30 minutes and two years from the date they are downloaded to your device.</p>

                <p>You can control and manage cookies in various ways. Please keep in mind that removing or blocking cookies can negatively impact your user experience and parts of our website may no longer be fully accessible.</p>

                <p>Most browsers automatically accept cookies, but you can choose whether or not to accept cookies through your browser controls, often found in your browser’s &quot;Tools&quot; or &quot;Preferences&quot; menu. For more information on how to modify your browser settings or how to block, manage or filter cookies can be found in your browser’s help file or through such sites as www.allaboutcookies.org</p>

                <p>Additionally, please note that blocking cookies may not completely prevent how we share information with third parties such as our advertising partners. To exercise your rights or opt-out of certain uses of your information by these parties, please follow the instructions in the &quot;Behavioural Advertising&quot; section above.</p>

                <h2>DO NOT TRACK</h2>
                <p>Please note that because there is no consistent industry understanding of how to respond to &quot;Do Not Track&quot; signals, we do not alter our data collection and usage practices when we detect such a signal from your browser.</p>

                <h2>CHANGES</h2>
                <p>We may update this Privacy Policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.</p>

                <h2>CONTACT</h2>
                <p>Questions about the Privacy Policy should be sent to us at hello@bedaskin.com.</p>

                <h2>WHERE IS THE PRODUCT MADE?</h2>
                <p>We are formulated and made in Singapore.</p>
            </ContentContainer>
            <BeKindSection />
            <InstagramFeed />
        </Layout>
    )
}

export default Privacy;
